import {
  AciliyetEnum,
  AdresEnum,
  BelgeTuruEnum,
  BildirimKategoriEnum,
  CinsiyetEnum,
  DigerKisiIslemBaglantisiEnum,
  GercekKisiIslemBaglantisiEnum,
  HesapTuruEnum,
  IletisimEnum,
  IslemCesidiEnum,
  IslemDurumuEnum,
  IslemKanaliEnum,
  IslemTuruEnum,
  KimlikTespitTuruEnum,
  KisitlamaTuruEnum,
  KurulusNeviEnum,
  MeslekEnum,
  ParaBirimiEnum,
  SupheKategorileriEnum,
  SupheninTespitEdildigiBirimEnum,
  TerorOrgutuEnum,
} from '../constant/SarConstants';

class SarXmlValidation {
  private readonly xmlContent: string;
  private validationResult: {
    isValid: boolean;
    errors: { message: string; lineStart: number; lineEnd: number; colStart: number; colEnd: number }[];
  } = {
    isValid: true,
    errors: [],
  };

  constructor(xmlContent: string) {
    this.xmlContent = xmlContent;
  }

  public validate() {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(this.xmlContent, 'text/xml');
    try {
      this.yukumluValidation(xmlDoc);
      this.bildirimKategorisiValidation(xmlDoc);
      this.yerelReferansNoValidation(xmlDoc);
      this.oncekiBildirimReferansNoValidation(xmlDoc);
      this.aciliyetValidation(xmlDoc);
      this.terorOrgutuValidation(xmlDoc);
      this.gercekKisilerValidation(xmlDoc);
      this.digerKisilerValidation(xmlDoc);
      this.supheliIslemlerValidation(xmlDoc);
      this.hesaplarValidation(xmlDoc);
      this.supheKategorileriValidation(xmlDoc);
      this.bildirimAciklamaValidation(xmlDoc);
    } catch (e) {
      this.validationResult.isValid = false;
      this.validationResult.errors.push({
        message: 'Xml formatı hatalı. Lütfen eksik-yanlış etiketleri düzenleyin.',
        lineStart: 0,
        lineEnd: 9999,
        colStart: 0,
        colEnd: 9999,
      });
    }

    return this.validationResult;
  }

  private yukumluValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('yukumlu')[0];
    const elementIndex = this.findElementIndex(xmlDoc, element, 'yukumlu');
    if (
      !(
        element &&
        element.textContent &&
        element.textContent.trim().length >= 4 &&
        element.textContent.trim().length <= 10 &&
        this.numberValidation(element.textContent)
      )
    ) {
      this.getLine(element, elementIndex, 'Yükümlü doğrulaması hatalı, 4-10 rakam içermelidir.');
    }
  }

  private bildirimKategorisiValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('bildirimkategorisi')[0];
    const elementIndex = this.findElementIndex(xmlDoc, element, 'bildirimkategorisi');
    if (!(element && element.textContent && Object.keys(BildirimKategoriEnum).includes(element.textContent))) {
      this.getLine(element, elementIndex, 'Bildirim kategorisi doğrulaması hatalı, geçerli bir kategori girilmelidir.');
    }
  }

  private yerelReferansNoValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('yerelreferansno')[0];
    const elementIndex = this.findElementIndex(xmlDoc, element, 'yerelreferansno');
    if (!(element && element.textContent && element.textContent.trim().length >= 1 && element.textContent.trim().length <= 50)) {
      this.getLine(element, elementIndex, 'Yerel referans no doğrulaması hatalı, 1-50 karakter içermelidir.');
    }
  }

  private oncekiBildirimReferansNoValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('oncekibildirimreferansno')[0];
    const elementIndex = this.findElementIndex(xmlDoc, element, 'oncekibildirimreferansno');
    if (element && element.textContent && !(element.textContent.trim().length >= 1 && element.textContent.trim().length <= 50)) {
      this.getLine(element, elementIndex, 'Önceki bildirim referans no doğrulaması hatalı, Opsiyoneldir ancak 1-50 karakter içermelidir.');
    }
  }

  private aciliyetValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('aciliyet')[0];
    if (!(element && element.textContent && Object.keys(AciliyetEnum).includes(element.textContent))) {
      this.getLine(element, 0, 'Aciliyet doğrulaması hatalı, geçerli kod girilmelidir.');
    }
  }

  private terorOrgutuValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('terororgutu')[0];
    const condition = xmlDoc.getElementsByTagName('bildirimkategorisi')[0];
    if (condition && condition.textContent === 'BK-02') {
      if (!(element && element.textContent && Object.keys(TerorOrgutuEnum).includes(element.textContent))) {
        this.getLine(element, 0, 'Terör örgütü doğrulaması hatalı, geçerli bir kategori girilmelidir.');
      }
    } else {
      if (element && element.textContent && !Object.keys(TerorOrgutuEnum).includes(element.textContent)) {
        this.getLine(element, 0, 'Terör örgütü doğrulaması hatalı, geçerli bir kategori girilmelidir.');
      }
    }
  }

  private gercekKisilerValidation(xmlDoc: Document) {
    const gercekKisiler = xmlDoc.getElementsByTagName('gercekkisi');
    if (gercekKisiler == undefined) return;

    for (let i = 0; i < gercekKisiler.length; i++) {
      const gercekKisi = gercekKisiler[i];
      const gercekKisiNumber = i + 1;

      const islemleBaglantisi = gercekKisi.getElementsByTagName('islemlebaglantisi')[0];
      const magdurCondition = gercekKisi.getElementsByTagName('magdur')[0];
      const islemBaglantisiIndex = this.findElementIndex(xmlDoc, islemleBaglantisi, 'islemlebaglantisi');
      const islemleBaglantisiValue = islemleBaglantisi?.textContent?.trim();
      const isValidGercekKisiIslemBaglantisi = (value: string): boolean => {
        return Object.keys(GercekKisiIslemBaglantisiEnum).includes(value);
      };
      if (magdurCondition && magdurCondition.textContent == 'H') {
        if (!(islemleBaglantisi && islemleBaglantisiValue && isValidGercekKisiIslemBaglantisi(islemleBaglantisiValue))) {
          this.getLine(
            islemleBaglantisi,
            islemBaglantisiIndex,
            `Gerçek kişi ${gercekKisiNumber}: <islemlebaglantisi> elementi doğrulaması hatalı. Geçerli bir işlem bağlantısı seçilmelidir`,
          );
        }
      } else {
        if (islemleBaglantisi && islemleBaglantisiValue && !isValidGercekKisiIslemBaglantisi(islemleBaglantisiValue)) {
          this.getLine(
            islemleBaglantisi,
            islemBaglantisiIndex,
            `Gerçek kişi ${gercekKisiNumber}: <islemlebaglantisi> elementi doğrulaması hatalı: Opsiyoneldir ancak varsa geçerli bir işlem bağlantısı seçilmelidir`,
          );
        }
      }

      const islemleBaglantisiAciklama = gercekKisi.getElementsByTagName('islemlebaglantisiaciklama')[0];
      const islemleBaglantisiAciklamaIndex = this.findElementIndex(xmlDoc, islemleBaglantisiAciklama, 'islemlebaglantisiaciklama');
      if (islemleBaglantisi && islemleBaglantisiValue == 'GB-05') {
        if (
          !(
            islemleBaglantisiAciklama &&
            islemleBaglantisiAciklama.textContent &&
            islemleBaglantisiAciklama.textContent.trim().length >= 1 &&
            islemleBaglantisiAciklama.textContent.trim().length <= 100
          )
        ) {
          this.getLine(
            islemleBaglantisiAciklama,
            islemleBaglantisiAciklamaIndex,
            `Gerçek kişi ${gercekKisiNumber}: <islemlebaglantisiaciklama> hatalı: İşlem bağlantısı GB-05 seçildiğinde işlem bağlantısı açıklaması 1-100 karakter uzunluğunda olmalıdır.`,
          );
        }
      } else {
        if (islemleBaglantisiAciklama && islemleBaglantisiAciklama.textContent && islemleBaglantisiAciklama.textContent.trim().length > 0) {
          this.getLine(
            islemleBaglantisiAciklama,
            islemleBaglantisiAciklamaIndex,
            `Gerçek kişi ${gercekKisiNumber}: <islemlebaglantisiaciklama> hatalı: İşlem bağlantısı GB-05 seçilmediğinde işlem bağlantısı açıklaması boş olmalıdır.`,
          );
        }
      }

      const adi = gercekKisi.getElementsByTagName('adi')[0];
      const adiIndex = this.findElementIndex(xmlDoc, adi, 'adi');
      if (!(adi && adi.textContent && adi.textContent.trim().length >= 1 && adi.textContent.trim().length <= 50)) {
        this.getLine(adi, adiIndex, `Gerçek kişi ${gercekKisiNumber}: <adi> doğrulaması hatalı, 1-50 karakter içermelidir.`);
      }

      const soyadi = gercekKisi.getElementsByTagName('soyadi')[0];
      const soyadiIndex = this.findElementIndex(xmlDoc, soyadi, 'soyadi');
      if (!(soyadi && soyadi.textContent && soyadi.textContent.trim().length >= 1 && soyadi.textContent.trim().length <= 50)) {
        this.getLine(soyadi, soyadiIndex, `Gerçek kişi ${gercekKisiNumber}: <soyadi> doğrulaması hatalı, 1-50 karakter içermelidir.`);
      }

      const tckn = gercekKisi.getElementsByTagName('tckn')[0];
      const kimlikTespitTuruCondition = gercekKisi.getElementsByTagName('kimliktespitturu')[0];
      const tckIndex = this.findElementIndex(xmlDoc, tckn, 'tckn');
      if (kimlikTespitTuruCondition && kimlikTespitTuruCondition.textContent == 'KTT-01') {
        if (!(tckn && tckn.textContent && tckn.textContent.trim().length == 11 && this.numberValidation(tckn.textContent))) {
          this.getLine(tckn, tckIndex, `Gerçek kişi ${gercekKisiNumber}: <tckn> doğrulaması hatalı, 11 rakamdan oluşan gerçek bir TCKN girilmelidir`);
        }
      } else {
        if (tckn && tckn.textContent && !(tckn.textContent.trim().length == 11 && this.numberValidation(tckn.textContent))) {
          this.getLine(
            tckn,
            tckIndex,
            `Gerçek kişi ${gercekKisiNumber}: <tckn> doğrulaması hatalı, opsiyoneldir ancak 11 rakamdan oluşan gerçek bir TCKN girilmelidir`,
          );
        }
      }

      const vkn = gercekKisi.getElementsByTagName('vkn')[0];
      const vknIndex = this.findElementIndex(xmlDoc, vkn, 'vkn');
      if (vkn && vkn.textContent && !(vkn.textContent.trim().length == 10 && this.numberValidation(vkn.textContent))) {
        this.getLine(
          vkn,
          vknIndex,
          `Gerçek kişi ${gercekKisiNumber}: <vkn> doğrulaması hatalı, opsiyoneldir ancak 10 rakamdan oluşan gerçek bir VKN girilmelidir`,
        );
      }

      const ykn = gercekKisi.getElementsByTagName('ykn')[0];
      const uyruguCondition = gercekKisi.getElementsByTagName('uyrugu')[0];
      const yknIndex = this.findElementIndex(xmlDoc, ykn, 'ykn');
      if (
        uyruguCondition &&
        kimlikTespitTuruCondition &&
        kimlikTespitTuruCondition.textContent == 'KTT-01' &&
        uyruguCondition.textContent?.toUpperCase() != 'TR'
      ) {
        if (!(ykn && ykn.textContent && ykn.textContent.trim().length == 11 && this.numberValidation(ykn.textContent))) {
          this.getLine(ykn, yknIndex, `Gerçek kişi ${gercekKisiNumber}: <ykn> doğrulaması hatalı, 11 rakamdan oluşan gerçek bir YKN girilmelidir`);
        }
      } else {
        if (ykn && ykn.textContent && !(ykn.textContent.trim().length == 11 && this.numberValidation(ykn.textContent))) {
          this.getLine(
            ykn,
            yknIndex,
            `Gerçek kişi ${gercekKisiNumber}: <ykn> doğrulaması hatalı, opsiyoneldir ancak 11 rakamdan oluşan gerçek bir YKN girilmelidir`,
          );
        }
      }

      const dogumTarihi = gercekKisi.getElementsByTagName('dogumtarihi')[0];
      const dogumTarihiIndex = this.findElementIndex(xmlDoc, dogumTarihi, 'dogumtarihi');
      if (
        kimlikTespitTuruCondition &&
        magdurCondition &&
        (magdurCondition.textContent == 'H' ||
          kimlikTespitTuruCondition.textContent == 'KTT-01' ||
          kimlikTespitTuruCondition.textContent == 'KTT-02' ||
          kimlikTespitTuruCondition.textContent == 'KTT-03')
      ) {
        if (!(dogumTarihi && dogumTarihi.textContent)) {
          this.getLine(dogumTarihi, dogumTarihiIndex, `Gerçek kişi ${i + 1}: <dogumtarihi> tarihi alanı boş olamaz.`);
        } else {
          this.tarihValidation(dogumTarihi, dogumTarihiIndex, dogumTarihi.textContent, `Gerçek kişi ${gercekKisiNumber}: <dogumtarihi>`);
        }
      } else {
        if (dogumTarihi && dogumTarihi.textContent) {
          this.tarihValidation(dogumTarihi, dogumTarihiIndex, dogumTarihi.textContent, `Gerçek kişi ${gercekKisiNumber}: <dogumtarihi> opsiyoneldir ancak`);
        }
      }

      const dogumYeri = gercekKisi.getElementsByTagName('dogumyeri')[0];
      const dogunYeriIndex = this.findElementIndex(xmlDoc, dogumTarihi, 'dogumyeri');
      if (dogumYeri && dogumYeri.textContent && !(dogumYeri.textContent.trim().length >= 0 && dogumYeri.textContent.trim().length <= 30)) {
        this.getLine(
          dogumYeri,
          dogunYeriIndex,
          `Gerçek kişi ${gercekKisiNumber}: <dogumyeri> doğrulaması hatalı, opsiyoneldir ancak 0-30 karakterden oluşmalıdır.`,
        );
      }

      const anaAdi = gercekKisi.getElementsByTagName('anaadi')[0];
      const anaAdiIndex = this.findElementIndex(xmlDoc, anaAdi, 'anaadi');
      if (anaAdi && anaAdi.textContent && !(anaAdi.textContent.trim().length >= 0 && anaAdi.textContent.trim().length <= 50)) {
        this.getLine(anaAdi, anaAdiIndex, `Gerçek kişi ${gercekKisiNumber}: <anaadi> doğrulaması hatalı, opsiyoneldir ancak 0-50 karakterden oluşmalıdır.`);
      }

      const babaAdi = gercekKisi.getElementsByTagName('babaadi')[0];
      const babaAdiIndex = this.findElementIndex(xmlDoc, babaAdi, 'babaadi');
      if (babaAdi && babaAdi.textContent && !(babaAdi.textContent.trim().length >= 0 && babaAdi.textContent.trim().length <= 50)) {
        this.getLine(babaAdi, babaAdiIndex, `Gerçek kişi ${gercekKisiNumber}: <babaadi> doğrulaması hatalı, opsiyoneldir ancak 0-50 karakterden oluşmalıdır.`);
      }

      const uyrugu = gercekKisi.getElementsByTagName('uyrugu')[0];
      const uyruguIndex = this.findElementIndex(xmlDoc, uyrugu, 'uyrugu');
      if (
        kimlikTespitTuruCondition &&
        magdurCondition &&
        magdurCondition.textContent == 'H' &&
        (kimlikTespitTuruCondition.textContent == 'KTT-01' ||
          kimlikTespitTuruCondition.textContent == 'KTT-02' ||
          kimlikTespitTuruCondition.textContent == 'KTT-03')
      ) {
        if (!(uyrugu && uyrugu.textContent && uyrugu.textContent.trim().length == 2)) {
          this.getLine(
            uyrugu,
            uyruguIndex,
            `Gerçek kişi ${gercekKisiNumber}: <uyrugu> doğrulaması hatalı, ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir`,
          );
        }
      } else {
        if (uyrugu && uyrugu.textContent && !(uyrugu.textContent.trim().length == 2)) {
          this.getLine(
            uyrugu,
            uyruguIndex,
            `Gerçek kişi ${gercekKisiNumber}: <uyrugu> doğrulaması hatalı, opsiyoneldir ancak ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir`,
          );
        }
      }

      const cinsiyeti = gercekKisi.getElementsByTagName('cinsiyeti')[0];
      const cinsiyetiIndex = this.findElementIndex(xmlDoc, cinsiyeti, 'cinsiyeti');
      if (magdurCondition && magdurCondition.textContent == 'H') {
        if (!(cinsiyeti && cinsiyeti.textContent && Object.keys(CinsiyetEnum).includes(cinsiyeti.textContent))) {
          this.getLine(cinsiyeti, cinsiyetiIndex, `Gerçek kişi ${gercekKisiNumber}: <cinsiyeti> geçerli bir değer girilmelidir`);
        }
      } else {
        if (cinsiyeti && cinsiyeti.textContent && !Object.keys(CinsiyetEnum).includes(cinsiyeti.textContent)) {
          this.getLine(
            cinsiyeti,
            cinsiyetiIndex,
            `Gerçek kişi ${gercekKisiNumber}: <cinsiyeti> doğrulaması hatalı: Opsiyoneldir ancak varsa geçerli bir değer olmalıdır`,
          );
        }
      }

      const kimlikBelgeleri = gercekKisi.getElementsByTagName('kimlikbelgeleri')[0];
      const kimlikBelgesi = kimlikBelgeleri?.getElementsByTagName('kimlikbelgesi');
      if (kimlikBelgesi != undefined) {
        for (let i = 0; i < kimlikBelgesi.length; i++) {
          const kimlikBelgesiElement = kimlikBelgesi[i];

          const belgeTuru = kimlikBelgesiElement.getElementsByTagName('belgeturu')[0];
          const belgeTuruIndex = this.findElementIndex(xmlDoc, belgeTuru, 'belgeturu');
          if (!(belgeTuru && belgeTuru.textContent && Object.keys(BelgeTuruEnum).includes(belgeTuru.textContent))) {
            this.getLine(
              belgeTuru,
              belgeTuruIndex,
              `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <belgeturu> doğrulaması hatalı. Belge türü doğru girilmeli.`,
            );
          }

          const belgeNumarasi = kimlikBelgesiElement.getElementsByTagName('belgenumarasi')[0];
          const belgeNumarasiIndex = this.findElementIndex(xmlDoc, belgeNumarasi, 'belgenumarasi');
          if (!(belgeNumarasi && belgeNumarasi.textContent && belgeNumarasi.textContent.trim().length >= 1 && belgeNumarasi.textContent.trim().length <= 20)) {
            this.getLine(
              belgeNumarasi,
              belgeNumarasiIndex,
              `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <belgenumarasi> doğrulaması hatalı. 1-20 karakter içermelidir.`,
            );
          }

          const gecerlilikTarihi = kimlikBelgesiElement.getElementsByTagName('gecerliliktarihi')[0];
          const gecerlilikTarihiIndex = this.findElementIndex(xmlDoc, gecerlilikTarihi, 'gecerliliktarihi');
          if (
            belgeTuru &&
            (belgeTuru.textContent == 'KT-02' || belgeTuru.textContent == 'KT-03' || belgeTuru.textContent == 'KT-04' || belgeTuru.textContent == 'KT-05')
          ) {
            if (!(gecerlilikTarihi && gecerlilikTarihi.textContent)) {
              this.getLine(
                gecerlilikTarihi,
                gecerlilikTarihiIndex,
                `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <gecerliliktarihi> doğrulaması hatalı. Belge türü KT-02, KT-03, KT-04, KT-05 girilmiş ise tarih girilmelidir.`,
              );
            } else {
              this.tarihValidation(
                gecerlilikTarihi,
                gecerlilikTarihiIndex,
                gecerlilikTarihi.textContent,
                `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <gecerliliktarihi>`,
              );
            }
          } else {
            if (gecerlilikTarihi && gecerlilikTarihi.textContent) {
              this.tarihValidation(
                gecerlilikTarihi,
                gecerlilikTarihiIndex,
                gecerlilikTarihi.textContent,
                `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: opsiyoneldir ancak <gecerliliktarihi>`,
              );
            }
          }
        }
      }

      const meslek = gercekKisi.getElementsByTagName('meslek')[0];
      const meslekIndex = this.findElementIndex(xmlDoc, meslek, 'meslek');
      if (
        kimlikTespitTuruCondition &&
        magdurCondition &&
        magdurCondition.textContent == 'H' &&
        (kimlikTespitTuruCondition.textContent == 'KTT-02' || kimlikTespitTuruCondition.textContent == 'KTT-03')
      ) {
        if (!(meslek && meslek.textContent && Object.keys(MeslekEnum).includes(meslek.textContent))) {
          this.getLine(
            meslek,
            meslekIndex,
            `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <meslek> doğrulaması hatalı. Geçerli meslek kodu seçilmelidir.`,
          );
        }
      } else {
        if (meslek && meslek.textContent && !Object.keys(MeslekEnum).includes(meslek.textContent)) {
          this.getLine(
            meslek,
            meslekIndex,
            `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <meslek> doğrulaması hatalı. Opsiyoneldir ancak geçerli meslek kodu seçilmelidir.`,
          );
        }
      }

      const ekBilgi = gercekKisi.getElementsByTagName('ekbilgi')[0];
      const ekBilgiIndex = this.findElementIndex(xmlDoc, ekBilgi, 'ekbilgi');
      if (ekBilgi && ekBilgi.textContent && !(ekBilgi.textContent.trim().length >= 0 && ekBilgi.textContent.trim().length <= 500)) {
        this.getLine(
          ekBilgi,
          ekBilgiIndex,
          `Gerçek kişi ${gercekKisiNumber}, kimlik belgesi ${i + 1}: <ekbilgi> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 0-500 olmalıdır.`,
        );
      }

      const adresler = gercekKisi.getElementsByTagName('adresler')[0];
      const adres = adresler?.getElementsByTagName('adres');
      if (adres != undefined) {
        for (let i = 0; i < adres.length; i++) {
          const adresElement = adres[i];

          const adresSatir = adresElement.getElementsByTagName('adressatir')[0];
          const adresSatirIndex = this.findElementIndex(xmlDoc, adresSatir, 'adressatir');
          const tip = adresElement.getAttribute('tip');
          const tipElement = adresElement;
          const tipElementIndex = this.findElementIndex(xmlDoc, tipElement, 'adres');
          if (tip && !Object.keys(AdresEnum).includes(tip)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir adres tipi (merkez, sube, diger) girilmeli.`,
              1,
            );
          } else if (tip && (tip.length < 1 || tip.length > 6)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-6 olmalıdır.`,
              1,
            );
          }
          if (!adresSatir || !adresSatir.textContent || adresSatir.textContent.trim().length === 0) {
            this.getLine(
              adresSatir,
              adresSatirIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <adressatir> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (!(adresSatir.textContent.trim().length >= 1 && adresSatir.textContent.trim().length <= 200)) {
            this.getLine(
              adresSatir,
              adresSatirIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <adressatir> doğrulaması hatalı. Karakter limiti 1-200 olmalıdır.`,
            );
          }

          const postaKodu = adresElement.getElementsByTagName('postakodu')[0];
          const postaKoduIndex = this.findElementIndex(xmlDoc, postaKodu, 'postakodu');
          if (postaKodu && postaKodu.textContent && postaKodu.textContent.trim().length > 0 && !(postaKodu.textContent.trim().length >= 1 && postaKodu.textContent.trim().length <= 10)) {
            this.getLine(
              postaKodu,
              postaKoduIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <postakodu> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-10 olmalıdır.`,
            );
          }

          const ilKodu = adresElement.getElementsByTagName('ilkodu')[0];
          const ilKoduIndex = this.findElementIndex(xmlDoc, ilKodu, 'ilkodu');
          if (
            ilKodu &&
            ilKodu.textContent &&
            !(ilKodu.textContent.trim().length >= 1 && ilKodu.textContent.trim().length <= 2 && this.numberValidation(ilKodu.textContent))
          ) {
            this.getLine(
              ilKodu,
              ilKoduIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <ilkodu> doğrulaması hatalı. Opsiyoneldir ancak 1-2 rakamdan oluşan plaka kodu olmalıdır.`,
            );
          }

          const ilceKodu = adresElement.getElementsByTagName('ilcekodu')[0];
          const ilceKoduIndex = this.findElementIndex(xmlDoc, ilceKodu, 'ilcekodu');
          if (ilceKodu && ilceKodu.textContent && !(ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
            this.getLine(
              ilceKodu,
              ilceKoduIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <ilcekodu> doğrulaması hatalı. Opsiyoneldir ancak 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
            );
          }

          const ulkeKodu = adresElement.getElementsByTagName('ulkekodu')[0];
          const ulkeKoduIndex = this.findElementIndex(xmlDoc, ulkeKodu, 'ulkekodu');
          if (!ulkeKodu || !ulkeKodu.textContent || ulkeKodu.textContent.trim().length === 0) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <ulkekodu> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (ulkeKodu.textContent.trim().length !== 2 || !this.letterValidation(ulkeKodu.textContent.trim())) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Gerçek kişi ${gercekKisiNumber}, adres ${i + 1}: <ulkekodu> doğrulaması hatalı. ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
            );
          }
        }
      }

      const iletisimBilgileri = gercekKisi.getElementsByTagName('iletisimbilgileri')[0];
      const iletisimBilgisi = iletisimBilgileri?.getElementsByTagName('iletisimbilgisi');
      if (iletisimBilgisi != undefined) {
        const iletisimBilgileriIndex = this.findElementIndex(xmlDoc, iletisimBilgileri, 'iletisimbilgileri');
        let emailExists = false;
        let phoneExists = false;
        for (let i = 0; i < iletisimBilgisi.length; i++) {
          const iletisimBilgisiElement = iletisimBilgisi[i];

          const tip = iletisimBilgisiElement.getAttribute('tip');
          const content = iletisimBilgisiElement?.textContent?.trim() || '';
          const iletisimBilgisiIndex = this.findElementIndex(xmlDoc, iletisimBilgisiElement, 'iletisimbilgisi');

          if (tip && !Object.keys(IletisimEnum).includes(tip)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Gerçek kişi ${gercekKisiNumber}, iletişim bilgisi ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir tip girilmeli.`,
            );
          }
          if (!content || content.length === 0) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Gerçek kişi ${gercekKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (!(content.length >= 7 && content.length <= 50)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Gerçek kişi ${gercekKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. 7-50 karakter girilmelidir.`,
            );
          }
          if (tip === 'eposta' && content && !content.includes('@')) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Gerçek kişi ${gercekKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. E-posta adresi "@" işareti içermelidir.`,
            );
          }
          if (tip === 'eposta') {
            emailExists = true;
          }
          if (tip === 'cep') {
            phoneExists = true;
          }
        }

        if (
          kimlikTespitTuruCondition &&
          (kimlikTespitTuruCondition.textContent === 'KTT-02' || kimlikTespitTuruCondition.textContent === 'KTT-03') &&
          (!emailExists || !phoneExists)
        ) {
          this.getLine(
            iletisimBilgileri,
            iletisimBilgileriIndex,
            `Gerçek kişi ${gercekKisiNumber}: Kimlik tespit türü ${kimlikTespitTuruCondition.textContent} seçildiğinde e-posta ve cep telefonu bilgisi doldurulmalıdır.`,
          );
        }
      }

      const kimlikBilgileriSahte = gercekKisi.getElementsByTagName('kimlikbilgilerisahte')[0];
      const kimlikBilgileriSahteIndex = this.findElementIndex(xmlDoc, kimlikBilgileriSahte, 'kimlikbilgilerisahte');
      if (!(kimlikBilgileriSahte && kimlikBilgileriSahte.textContent && (kimlikBilgileriSahte.textContent == 'E' || kimlikBilgileriSahte.textContent == 'H'))) {
        this.getLine(
          kimlikBilgileriSahte,
          kimlikBilgileriSahteIndex,
          `Gerçek kişi ${gercekKisiNumber}: <kimlikbilgilerisahte> doğrulaması hatalı, E(Sahte) veya H(Gerçek) değerleri girilmelidir.`,
        );
      }

      const magdur = gercekKisi.getElementsByTagName('magdur')[0];
      const magdurIndex = this.findElementIndex(xmlDoc, magdur, 'magdur');
      if (!(magdur && magdur.textContent && (magdur.textContent == 'E' || magdur.textContent == 'H'))) {
        this.getLine(magdur, magdurIndex, `Gerçek kişi ${gercekKisiNumber}: <magdur> doğrulaması hatalı, E(Mağdur) veya H(Mağdur Değil) girilmelidir.`);
      }

      const kimlikTespitTuruTip = gercekKisi.getElementsByTagName('kimliktespitturu')[0];
      const kimlikTespitTuruTipIndex = this.findElementIndex(xmlDoc, kimlikTespitTuruTip, 'kimliktespitturu');
      if (!(kimlikTespitTuruTip && kimlikTespitTuruTip.textContent && Object.keys(KimlikTespitTuruEnum).includes(kimlikTespitTuruTip.textContent))) {
        this.getLine(
          kimlikTespitTuruTip,
          kimlikTespitTuruTipIndex,
          `Gerçek kişi ${gercekKisiNumber}: <kimliktespitturu> doğrulaması hatalı. Geçerli bir tip girilmelidir.`,
        );
      }
    }
  }

  private digerKisilerValidation(xmlDoc: Document) {
    const digerKisiler = xmlDoc.getElementsByTagName('digerkisi');
    if (digerKisiler == undefined) return;

    for (let i = 0; i < digerKisiler.length; i++) {
      const digerKisi = digerKisiler[i];
      const digerKisiNumber = i + 1;

      const islemleBaglantisi = digerKisi.getElementsByTagName('islemlebaglantisi')[0];
      const magdurCondition = digerKisi.getElementsByTagName('magdur')[0];
      const islemBaglantisiIndex = this.findElementIndex(xmlDoc, islemleBaglantisi, 'islemlebaglantisi');
      const islemleBaglantisiValue = islemleBaglantisi?.textContent?.trim();
      const isValidDigerKisiIslemBaglantisi = (value: string): boolean => {
        return Object.keys(DigerKisiIslemBaglantisiEnum).includes(value);
      };
      if (magdurCondition && magdurCondition.textContent == 'H') {
        if (!(islemleBaglantisi && islemleBaglantisiValue && isValidDigerKisiIslemBaglantisi(islemleBaglantisiValue))) {
          this.getLine(
            islemleBaglantisi,
            islemBaglantisiIndex,
            `Diğer kişi ${digerKisiNumber}: <islemlebaglantisi> elementi doğrulaması hatalı. Geçerli alan girilmelidir.`,
          );
        }
      } else {
        if (islemleBaglantisi && islemleBaglantisiValue && !isValidDigerKisiIslemBaglantisi(islemleBaglantisiValue)) {
          this.getLine(
            islemleBaglantisi,
            islemBaglantisiIndex,
            `Diğer kişi ${digerKisiNumber}: <islemlebaglantisi> elementi doğrulaması hatalı: Opsiyoneldir ancak varsa geçerli bir değer girilmelidir.`,
          );
        }
      }

      const islemleBaglantisiAciklama = digerKisi.getElementsByTagName('islemlebaglantisiaciklama')[0];
      const islemleBaglantisiAciklamaIndex = this.findElementIndex(xmlDoc, islemleBaglantisiAciklama, 'islemlebaglantisiaciklama');
      if (islemleBaglantisi && islemleBaglantisiValue == 'DB-02') {
        if (
          !(
            islemleBaglantisiAciklama &&
            islemleBaglantisiAciklama.textContent &&
            islemleBaglantisiAciklama.textContent.trim().length >= 1 &&
            islemleBaglantisiAciklama.textContent.trim().length <= 100
          )
        ) {
          this.getLine(
            islemleBaglantisiAciklama,
            islemleBaglantisiAciklamaIndex,
            `Diğer kişi ${digerKisiNumber}: <islemlebaglantisiaciklama> hatalı: DB-02 seçildiğinde işlem bağlantısı açıklaması 1-100 karakter uzunluğunda olmalıdır.`,
          );
        }
      } else {
        if (islemleBaglantisiAciklama && islemleBaglantisiAciklama.textContent && islemleBaglantisiAciklama.textContent.trim().length > 0) {
          this.getLine(
            islemleBaglantisiAciklama,
            islemleBaglantisiAciklamaIndex,
            `Diğer kişi ${digerKisiNumber}: <islemlebaglantisiaciklama> hatalı: DB-02 seçilmediğinde işlem bağlantısı açıklaması boş olmalıdır.`,
          );
        }
      }

      const kurulusnevi = digerKisi.getElementsByTagName('kurulusnevi')[0];
      const kurulusneviIndex = this.findElementIndex(xmlDoc, kurulusnevi, 'kurulusnevi');
      if (!(kurulusnevi && kurulusnevi.textContent && Object.keys(KurulusNeviEnum).includes(kurulusnevi.textContent))) {
        this.getLine(kurulusnevi, kurulusneviIndex, `Diğer kişi ${digerKisiNumber}: <kurulusnevi> elementi doğrulaması hatalı. Geçerli bir alan girilmelidir.`);
      }

      const unvan = digerKisi.getElementsByTagName('unvan')[0];
      const unvanIndex = this.findElementIndex(xmlDoc, unvan, 'unvan');
      if (!(unvan && unvan.textContent && unvan.textContent.trim().length >= 1 && unvan.textContent.trim().length <= 200)) {
        this.getLine(unvan, unvanIndex, `Diğer kişi ${digerKisiNumber}: <unvan> elementi doğrulaması hatalı. 1-200 karakter içermelidir.`);
      }

      const isletmeadi = digerKisi.getElementsByTagName('isletmeadi')[0];
      const isletmeadiIndex = this.findElementIndex(xmlDoc, isletmeadi, 'isletmeadi');
      if (isletmeadi && isletmeadi.textContent && !(isletmeadi.textContent.trim().length >= 0 && isletmeadi.textContent.trim().length <= 200)) {
        this.getLine(
          isletmeadi,
          isletmeadiIndex,
          `Diğer kişi ${digerKisiNumber}: <isletmeadi> elementi doğrulaması hatalı. Opsiyoneldir ancak 0-200 karakter içermelidir.`,
        );
      }

      const vkn = digerKisi.getElementsByTagName('vkn')[0];
      const vknIndex = this.findElementIndex(xmlDoc, vkn, 'vkn');
      if (vkn && vkn.textContent && !(vkn.textContent.trim().length == 10 && this.numberValidation(vkn.textContent))) {
        this.getLine(vkn, vknIndex, `Diğer kişi ${digerKisiNumber}: <vkn> elementi doğrulaması hatalı. 10 rakamdan oluşan gerçek bir VKN girilmelidir.`);
      }

      const sicilno = digerKisi.getElementsByTagName('sicilno')[0];
      const sicilnoIndex = this.findElementIndex(xmlDoc, sicilno, 'sicilno');
      if (sicilno && sicilno.textContent && !(sicilno.textContent.trim().length >= 0 && sicilno.textContent.trim().length <= 50)) {
        this.getLine(
          sicilno,
          sicilnoIndex,
          `Diğer kişi ${digerKisiNumber}: <sicilno> elementi doğrulaması hatalı. Opsiyoneldir ancak 0-50 karakter içermelidir.`,
        );
      }

      const faaliyetkonusu = digerKisi.getElementsByTagName('faaliyetkonusu')[0];
      const faaliyetkonusuIndex = this.findElementIndex(xmlDoc, faaliyetkonusu, 'faaliyetkonusu');
      if (faaliyetkonusu && faaliyetkonusu.textContent && !(faaliyetkonusu.textContent.trim().length >= 0 && faaliyetkonusu.textContent.trim().length <= 100)) {
        this.getLine(
          faaliyetkonusu,
          faaliyetkonusuIndex,
          `Diğer kişi ${digerKisiNumber}: <faaliyetkonusu> elementi doğrulaması hatalı. Opsiyoneldir ancak 0-100 karakter içermelidir.`,
        );
      }

      const ulkeKodu = digerKisi.getElementsByTagName('ulkekodu')[0];
      const ulkeKoduIndex = this.findElementIndex(xmlDoc, ulkeKodu, 'ulkekodu');
      const ulkeKoduValue = ulkeKodu?.textContent?.trim() ?? '';
      const isValidUlkeKodu = /^[A-Za-z]{2}$/.test(ulkeKoduValue);
      
      if (magdurCondition && magdurCondition.textContent == 'H') {
        if (!(ulkeKodu && ulkeKoduValue && isValidUlkeKodu)) {
          this.getLine(
            ulkeKodu,
            ulkeKoduIndex,
            `Diğer kişi ${digerKisiNumber}: <ulkekodu> doğrulaması hatalı. ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
          );
        }
      } else {
        if (ulkeKodu && ulkeKoduValue && !isValidUlkeKodu) {
          this.getLine(
            ulkeKodu,
            ulkeKoduIndex,
            `Diğer kişi ${digerKisiNumber}: <ulkekodu> doğrulaması hatalı. Opsiyoneldir ancak ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
          );
        }
      }

      const ilKodu = digerKisi.getElementsByTagName('ilkodu')[0];
      const ilKoduIndex = this.findElementIndex(xmlDoc, ilKodu, 'ilkodu');
      if (
        ilKodu &&
        ilKodu.textContent &&
        !(ilKodu.textContent.trim().length >= 1 && ilKodu.textContent.trim().length <= 2 && this.numberValidation(ilKodu.textContent))
      ) {
        this.getLine(
          ilKodu,
          ilKoduIndex,
          `Diğer kişi ${digerKisiNumber}: <ilkodu> doğrulaması hatalı. Opsiyoneldir ancak 1-2 karakter içeren gerçek il koduları girilmelidir.`,
        );
      }

      const ilceKodu = digerKisi.getElementsByTagName('ilcekodu')[0];
      const ilceKoduIndex = this.findElementIndex(xmlDoc, ilceKodu, 'ilcekodu');
      if (ilceKodu && ilceKodu.textContent && !(ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
        this.getLine(
          ilceKodu,
          ilceKoduIndex,
          `Diğer kişi ${digerKisiNumber}: <ilcekodu> doğrulaması hatalı. Opsiyoneldir ancak 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
        );
      }

      const kurulustarihi = digerKisi.getElementsByTagName('kurulustarihi')[0];
      const kurulustarihiIndex = this.findElementIndex(xmlDoc, kurulustarihi, 'kurulustarihi');
      if (kurulustarihi && kurulustarihi.textContent) {
        this.tarihValidation(kurulustarihi, kurulustarihiIndex, kurulustarihi.textContent, `Diğer kişi ${digerKisiNumber}: Opsiyoneldir ancak <kurulustarihi>`);
      }

      const websitesi = digerKisi.getElementsByTagName('websitesi')[0];
      const websitesiIndex = this.findElementIndex(xmlDoc, websitesi, 'websitesi');
      if (websitesi && websitesi.textContent && !(websitesi.textContent.trim().length >= 0 && websitesi.textContent.trim().length <= 50)) {
        this.getLine(
          websitesi,
          websitesiIndex,
          `Diğer kişi ${digerKisiNumber}: <websitesi> elementi doğrulaması hatalı. Opsiyoneldir ancak 0-50 karakter içermelidir.`,
        );
      }

      const ekbilgi = digerKisi.getElementsByTagName('ekbilgi')[0];
      const ekbilgiIndex = this.findElementIndex(xmlDoc, ekbilgi, 'ekbilgi');
      if (ekbilgi && ekbilgi.textContent && !(ekbilgi.textContent.trim().length >= 0 && ekbilgi.textContent.trim().length <= 500)) {
        this.getLine(
          ekbilgi,
          ekbilgiIndex,
          `Diğer kişi ${digerKisiNumber}: <ekbilgi> elementi doğrulaması hatalı. Opsiyoneldir ancak 0-500 karakter içermelidir.`,
        );
      }

      const adresler = digerKisi.getElementsByTagName('adresler')[0];
      const adres = adresler?.getElementsByTagName('adres');
      if (adres != undefined) {
        for (let i = 0; i < adres.length; i++) {
          const adresElement = adres[i];

          const adresSatir = adresElement.getElementsByTagName('adressatir')[0];
          const adresSatirIndex = this.findElementIndex(xmlDoc, adresSatir, 'adressatir');
          const tip = adresElement.getAttribute('tip');
          const tipElement = adresElement;
          const tipElementIndex = this.findElementIndex(xmlDoc, tipElement, 'adres');
          if (tip && !Object.keys(AdresEnum).includes(tip)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir adres tipi (merkez, sube, diger) girilmeli.`,
              1,
            );
          } else if (tip && (tip.length < 1 || tip.length > 6)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-6 olmalıdır.`,
              1,
            );
          }
          if (!(adresSatir && adresSatir.textContent && adresSatir.textContent.trim().length >= 1 && adresSatir.textContent.trim().length <= 200)) {
            this.getLine(
              adresSatir,
              adresSatirIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <adressatir> doğrulaması hatalı. 1-200 karakter içermelidir.`,
            );
          }

          const postaKodu = adresElement.getElementsByTagName('postakodu')[0];
          const postaKoduIndex = this.findElementIndex(xmlDoc, postaKodu, 'postakodu');
          if (postaKodu && postaKodu.textContent && postaKodu.textContent.trim().length > 0 && !(postaKodu.textContent.trim().length >= 1 && postaKodu.textContent.trim().length <= 10)) {
            this.getLine(
              postaKodu,
              postaKoduIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <postakodu> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-10 olmalıdır.`,
            );
          }

          const ilKodu = adresElement.getElementsByTagName('ilkodu')[0];
          const ilKoduIndex = this.findElementIndex(xmlDoc, ilKodu, 'ilkodu');
          if (
            ilKodu &&
            ilKodu.textContent &&
            !(ilKodu.textContent.trim().length >= 1 && ilKodu.textContent.trim().length <= 2 && this.numberValidation(ilKodu.textContent))
          ) {
            this.getLine(
              ilKodu,
              ilKoduIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <ilkodu> doğrulaması hatalı. Opsiyoneldir ancak 1-2 rakamdan oluşan plaka kodu olmalıdır.`,
            );
          }

          const ilceKodu = adresElement.getElementsByTagName('ilcekodu')[0];
          const ilceKoduIndex = this.findElementIndex(xmlDoc, ilceKodu, 'ilcekodu');
          if (ilceKodu && ilceKodu.textContent && !(ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
            this.getLine(
              ilceKodu,
              ilceKoduIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <ilcekodu> doğrulaması hatalı. Opsiyoneldir ancak 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
            );
          }

          const ulkeKodu = adresElement.getElementsByTagName('ulkekodu')[0];
          const ulkeKoduIndex = this.findElementIndex(xmlDoc, ulkeKodu, 'ulkekodu');
          if (!ulkeKodu || !ulkeKodu.textContent || ulkeKodu.textContent.trim().length === 0) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <ulkekodu> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (ulkeKodu.textContent.trim().length !== 2 || !this.letterValidation(ulkeKodu.textContent.trim())) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Diğer kişi ${digerKisiNumber}, adres ${i + 1}: <ulkekodu> doğrulaması hatalı. ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
            );
          }
        }
      }

      const iletisimBilgileri = digerKisi.getElementsByTagName('iletisimbilgileri')[0];
      const iletisimBilgisi = iletisimBilgileri?.getElementsByTagName('iletisimbilgisi');
      if (iletisimBilgisi != undefined && iletisimBilgisi.length > 0) {
        const iletisimBilgileriIndex = this.findElementIndex(xmlDoc, iletisimBilgileri, 'iletisimbilgileri');
        for (let i = 0; i < iletisimBilgisi.length; i++) {
          const iletisimBilgisiElement = iletisimBilgisi[i];

          const tip = iletisimBilgisiElement.getAttribute('tip');
          const content = iletisimBilgisiElement?.textContent?.trim() || '';
          const iletisimBilgisiIndex = this.findElementIndex(xmlDoc, iletisimBilgisiElement, 'iletisimbilgisi');

          if (tip && !Object.keys(IletisimEnum).includes(tip)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Diğer kişi ${digerKisiNumber}, iletişim bilgisi ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir tip girilmeli.`,
            );
          }
          if (!content || content.length === 0) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Diğer kişi ${digerKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (!(content.length >= 7 && content.length <= 50)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Diğer kişi ${digerKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. 7-50 karakter girilmelidir.`,
            );
          }
          if (tip === 'eposta' && content && !content.includes('@')) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Diğer kişi ${digerKisiNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. E-posta adresi "@" işareti içermelidir.`,
            );
          }
        }
      } else {
        const iletisimBilgileriIndex = iletisimBilgileri
          ? this.findElementIndex(xmlDoc, iletisimBilgileri, 'iletisimbilgileri')
          : this.findElementIndex(xmlDoc, digerKisi, 'digerkisi');
        this.getLine(
          iletisimBilgileri || digerKisi,
          iletisimBilgileriIndex,
          `Diğer kişi ${digerKisiNumber}, <iletisimbilgileri> en az bir iletişim bilgisi (İş Telefonu, Ev Telefonu, Cep Telefonu, Diğer Telefon, Faks veya E-posta) girilmesi zorunludur`,
        );
      }

      const kimlikBilgileriSahte = digerKisi.getElementsByTagName('kimlikbilgilerisahte')[0];
      const kimlikBilgileriSahteIndex = this.findElementIndex(xmlDoc, kimlikBilgileriSahte, 'kimlikbilgilerisahte');
      if (!(kimlikBilgileriSahte && kimlikBilgileriSahte.textContent && (kimlikBilgileriSahte.textContent == 'E' || kimlikBilgileriSahte.textContent == 'H'))) {
        this.getLine(
          kimlikBilgileriSahte,
          kimlikBilgileriSahteIndex,
          `Diğer kişi ${digerKisiNumber}: <kimlikbilgilerisahte> doğrulaması hatalı, E(Sahte) veya H(Gerçek) girilmelidir.`,
        );
      }

      const magdur = digerKisi.getElementsByTagName('magdur')[0];
      const magdurIndex = this.findElementIndex(xmlDoc, magdur, 'magdur');
      if (!(magdur && magdur.textContent && (magdur.textContent == 'E' || magdur.textContent == 'H'))) {
        this.getLine(magdur, magdurIndex, `Diğer kişi ${digerKisiNumber}: <magdur> doğrulaması hatalı, E(Mağdur) veya H(Mağdur Değil) girilmelidir.`);
      }
    }
  }

  private supheliIslemlerValidation(xmlDoc: Document) {
    const supheliIslemler = xmlDoc.getElementsByTagName('supheliislem');
    if (supheliIslemler == undefined) return;

    for (let i = 0; i < supheliIslemler.length; i++) {
      const supheliIslem = supheliIslemler[i];
      const supheliIslemNumber = i + 1;

      const islemcesidi = supheliIslem.getElementsByTagName('islemcesidi')[0];
      const islemcesidiIndex = this.findElementIndex(xmlDoc, islemcesidi, 'islemcesidi');
      if (!(islemcesidi && islemcesidi.textContent && Object.keys(IslemCesidiEnum).includes(islemcesidi.textContent))) {
        this.getLine(islemcesidi, islemcesidiIndex, `Şüpheli işlem ${supheliIslemNumber}: <supheliislem> doğrulaması hatalı, geçerli işlem çeşidi seçilmeli`);
      }

      const islemtarihi1 = supheliIslem.getElementsByTagName('islemtarihi1')[0];
      const islemtarihi1Index = this.findElementIndex(xmlDoc, islemtarihi1, 'islemtarihi1');
      if (!(islemtarihi1 && islemtarihi1.textContent)) {
        this.getLine(islemtarihi1, islemtarihi1Index, `Şüpheli işlem ${supheliIslemNumber}: <islemtarihi1> tarihi alanı boş olamaz.`);
      } else {
        this.tarihValidation(islemtarihi1, islemtarihi1Index, islemtarihi1.textContent, `Şüpheli işlem ${supheliIslemNumber}: <islemtarihi1>`);
      }

      const islemtarihi2 = supheliIslem.getElementsByTagName('islemtarihi2')[0];
      const islemtarihi2Index = this.findElementIndex(xmlDoc, islemtarihi2, 'islemtarihi2');
      if (islemcesidi && islemcesidi.textContent == 'C-02') {
        if (!(islemtarihi2 && islemtarihi2.textContent)) {
          this.getLine(
            islemtarihi2,
            islemtarihi2Index,
            `Şüpheli işlem ${supheliIslemNumber}: İşlem çeşidi C-02 şeçildiğinde<islemtarihi2> tarihi alanı boş olamaz.`,
          );
        } else {
          this.tarihValidation(islemtarihi2, islemtarihi2Index, islemtarihi2.textContent, `Şüpheli işlem ${supheliIslemNumber}: <islemtarihi2>`);
        }
      } else {
        if (islemtarihi2 && islemtarihi2.textContent) {
          this.tarihValidation(
            islemtarihi2,
            islemtarihi2Index,
            islemtarihi2.textContent,
            `Şüpheli işlem ${supheliIslemNumber}: Opsiyoneldir ancak <islemtarihi2>`,
          );
        }
      }

      const islemdurumu = supheliIslem.getElementsByTagName('islemdurumu')[0];
      const islemdurumuIndex = this.findElementIndex(xmlDoc, islemdurumu, 'islemdurumu');
      if (!(islemdurumu && islemdurumu.textContent && Object.keys(IslemDurumuEnum).includes(islemdurumu.textContent))) {
        this.getLine(islemdurumu, islemdurumuIndex, `Şüpheli işlem ${supheliIslemNumber}: <islemdurumu> doğrulaması hatalı, geçerli işlem durumu seçilmeli`);
      }

      const hesababagli = supheliIslem.getElementsByTagName('hesababagli')[0];
      const hesababagliIndex = this.findElementIndex(xmlDoc, hesababagli, 'hesababagli');
      if (!(hesababagli && hesababagli.textContent && (hesababagli.textContent == 'E' || hesababagli.textContent == 'H'))) {
        this.getLine(
          hesababagli,
          hesababagliIndex,
          `Şüpheli işlem ${supheliIslemNumber}: <hesababagli> doğrulaması hatalı, E(Bağlı) veya H(Bağlı Değil) değerleri girilmelidir.`,
        );
      }

      const tutartp = supheliIslem.getElementsByTagName('tutartp')[0];
      const tutartpIndex = this.findElementIndex(xmlDoc, tutartp, 'tutartp');
      if (islemdurumu && islemdurumu.textContent == 'D-01') {
        if (!(tutartp && tutartp.textContent)) {
          this.getLine(tutartp, tutartpIndex, `Şüpheli işlem ${supheliIslemNumber}: <tutartp> alanı boş olamaz.`);
        } else {
          const tpValue = tutartp.textContent.trim();
          const tpRegex = /^\d{1,15}(\.\d{1,5})?$/;
          if (!tpRegex.test(tpValue)) {
            this.getLine(
              tutartp,
              tutartpIndex,
              `Şüpheli işlem ${supheliIslemNumber}: <tutartp> hatalı: Değer ${tpValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
            );
          }
        }
      } else {
        if (tutartp && tutartp.textContent) {
          const tpValue = tutartp.textContent.trim();
          const tpRegex = /^\d{1,15}(\.\d{1,5})?$/;
          if (!tpRegex.test(tpValue)) {
            this.getLine(
              tutartp,
              tutartpIndex,
              `Şüpheli işlem ${supheliIslemNumber}: <tutartp> hatalı: Değer ${tpValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
            );
          }
        }
      }

      const tutar = supheliIslem.getElementsByTagName('tutar')[0];
      const tutarIndex = this.findElementIndex(xmlDoc, tutar, 'tutar');
      if (islemdurumu && islemdurumu.textContent == 'D-01') {
        if (!(tutar && tutar.textContent)) {
          this.getLine(tutar, tutarIndex, `Şüpheli işlem ${supheliIslemNumber}: <tutar> alanı boş olamaz.`);
        } else {
          const tpValue = tutar.textContent.trim();
          const tpRegex = /^\d{1,15}(\.\d{1,5})?$/;
          if (!tpRegex.test(tpValue)) {
            this.getLine(
              tutar,
              tutarIndex,
              `Şüpheli işlem ${supheliIslemNumber}: <tutar> hatalı: Değer ${tpValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
            );
          }
        }
      } else {
        if (tutar && tutar.textContent) {
          const tpValue = tutar.textContent.trim();
          const tpRegex = /^\d{1,15}(\.\d{1,5})?$/;
          if (!tpRegex.test(tpValue)) {
            this.getLine(
              tutar,
              tutarIndex,
              `Şüpheli işlem ${supheliIslemNumber}: <tutar> hatalı: Değer ${tpValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
            );
          }
        }
      }

      const parabirimi = supheliIslem.getElementsByTagName('parabirimi')[0];
      const parabirimiIndex = this.findElementIndex(xmlDoc, parabirimi, 'parabirimi');
      if (islemdurumu && islemdurumu.textContent == 'D-01') {
        if (!(parabirimi && parabirimi.textContent && parabirimi.textContent.trim().length > 0)) {
          this.getLine(parabirimi, parabirimiIndex, `Şüpheli işlem ${supheliIslemNumber}: <parabirimi> alanı boş olamaz.`);
        } else if (!Object.keys(ParaBirimiEnum).includes(parabirimi.textContent)) {
          this.getLine(parabirimi, parabirimiIndex, `Şüpheli işlem ${supheliIslemNumber}: <parabirimi> doğrulaması hatalı, geçerli para birimi seçilmeli`);
        }
      } else {
        if (parabirimi && parabirimi.textContent && !Object.keys(ParaBirimiEnum).includes(parabirimi.textContent)) {
          this.getLine(
            parabirimi,
            parabirimiIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <parabirimi> doğrulaması hatalı, opsiyoneldir ancak geçerli para birimi seçilmeli`,
          );
        }
      }

      const islemturu = supheliIslem.getElementsByTagName('islemturu')[0];
      const islemturuIndex = this.findElementIndex(xmlDoc, islemturu, 'islemturu');
      const islemTuruEnumCheck = () => {
        if (islemturu && islemturu.textContent && islemturu.textContent.trim().length >= 1 && islemturu.textContent.trim().length <= 500) {
          const islemTypes = islemturu.textContent.split(',');
          islemTypes.forEach((islemType) => {
            if (!Object.keys(IslemTuruEnum).includes(islemType.trim())) {
              this.getLine(
                islemturu,
                islemturuIndex,
                `Şüpheli işlem ${supheliIslemNumber}: <islemturu> doğrulaması hatalı: ${islemType.trim()} geçerli bir işlem türü değil.`,
              );
            }
          });
        }
      };
      if (islemdurumu && islemdurumu.textContent == 'D-01') {
        if (!(islemturu && islemturu.textContent && islemturu.textContent.trim().length >= 0 && islemturu.textContent.trim().length <= 500)) {
          this.getLine(
            islemturu,
            islemturuIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <islemturu> hatalı: D-01 seçildiğinde işlem türü 1-500 karakter uzunluğunda olmalıdır.`,
          );
        } else {
          islemTuruEnumCheck();
        }
      } else {
        islemTuruEnumCheck();
      }

      const islemkanali = supheliIslem.getElementsByTagName('islemkanali')[0];
      const islemkanaliIndex = this.findElementIndex(xmlDoc, islemkanali, 'islemkanali');
      const islemKanaliEnumCheck = () => {
        if (islemkanali && islemkanali.textContent && islemkanali.textContent.trim().length >= 1 && islemkanali.textContent.trim().length <= 500) {
          const islemTypes = islemkanali.textContent.split(',');
          islemTypes.forEach((islemType) => {
            if (!Object.keys(IslemKanaliEnum).includes(islemType.trim())) {
              this.getLine(
                islemkanali,
                islemkanaliIndex,
                `Şüpheli işlem ${supheliIslemNumber}: <islemkanali> doğrulaması hatalı: ${islemType.trim()} geçerli bir işlem kanalı değil.`,
              );
            }
          });
        }
      };
      if (islemdurumu && islemdurumu.textContent == 'D-01') {
        if (!(islemkanali && islemkanali.textContent && islemkanali.textContent.trim().length >= 1 && islemkanali.textContent.trim().length <= 500)) {
          this.getLine(
            islemkanali,
            islemkanaliIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <islemkanali> hatalı: D-01 seçildiğinde işlem kanalı 1-500 karakter uzunluğunda olmalıdır.`,
          );
        } else {
          islemKanaliEnumCheck();
        }
      } else {
        islemKanaliEnumCheck();
      }

      const ip = supheliIslem.getElementsByTagName('ipv4')[0];
      const ipIndex = this.findElementIndex(xmlDoc, ip, 'ipv4');
      const ipv4Pattern =
        /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
      const ipv6Pattern = /^([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)$/;
      if (ip && ip.textContent && !(ipv4Pattern.test(ip.textContent) || ipv6Pattern.test(ip.textContent))) {
        this.getLine(ip, ipIndex, `Şüpheli işlem ${supheliIslemNumber}: <ipv4> hatalı: IP adresi geçerli bir IPv4 veya IPv6 adresi olmalıdır.`);
      }

      const port = supheliIslem.getElementsByTagName('port')[0];
      const portIndex = this.findElementIndex(xmlDoc, port, 'port');
      if (port && port.textContent && !(port.textContent.length >= 1 && port.textContent.length <= 5)) {
        this.getLine(port, portIndex, `Şüpheli işlem ${supheliIslemNumber}: <port> hatalı: Opsiyoneldir ancak 1-5 karakter içermeli.`);
      }

      const islemaciklamasi = supheliIslem.getElementsByTagName('islemaciklamasi')[0];
      const islemaciklamasiIndex = this.findElementIndex(xmlDoc, islemaciklamasi, 'islemaciklamasi');
      if (islemaciklamasi && islemaciklamasi.textContent && !(islemaciklamasi.textContent.length >= 0 && islemaciklamasi.textContent.length <= 500)) {
        this.getLine(
          islemaciklamasi,
          islemaciklamasiIndex,
          `Şüpheli işlem ${supheliIslemNumber}: <islemaciklamasi> hatalı: Opsiyoneldir ancak 0-500 karakter içermeli.`,
        );
      }

      const ulkeKodu = supheliIslem.getElementsByTagName('ulkekodu')[0];
      const ulkeKoduIndex = this.findElementIndex(xmlDoc, ulkeKodu, 'ulkekodu');
      if (islemkanali && (islemkanali.textContent == 'KK-01' || islemkanali.textContent == 'KK-10')) {
        if (!(ulkeKodu && ulkeKodu.textContent && ulkeKodu.textContent.trim().length == 2 && this.letterValidation(ulkeKodu.textContent.trim()))) {
          this.getLine(
            ulkeKodu,
            ulkeKoduIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <ulkekodu> doğrulaması hatalı. ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
          );
        }
      } else {
        if (ulkeKodu && ulkeKodu.textContent && !(ulkeKodu.textContent.trim().length == 2 && this.letterValidation(ulkeKodu.textContent.trim()))) {
          this.getLine(
            ulkeKodu,
            ulkeKoduIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <ulkekodu> doğrulaması hatalı. Opsiyoneldir ancak ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
          );
        }
      }

      const ilKodu = supheliIslem.getElementsByTagName('ilkodu')[0];
      const ilKoduIndex = this.findElementIndex(xmlDoc, ilKodu, 'ilkodu');
      if (islemkanali && (islemkanali.textContent == 'KK-01' || islemkanali.textContent == 'KK-10')) {
        if (
          !(
            ilKodu &&
            ilKodu.textContent &&
            ilKodu.textContent.trim().length >= 1 &&
            ilKodu.textContent.trim().length <= 2 &&
            this.numberValidation(ilKodu.textContent)
          )
        ) {
          this.getLine(ilKodu, ilKoduIndex, `Şüpheli işlem ${supheliIslemNumber}: <ilkodu> doğrulaması hatalı. Karakter limiti 1-2.`);
        }
      } else {
        if (
          ilKodu &&
          ilKodu.textContent &&
          !(ilKodu.textContent.trim().length >= 1 && ilKodu.textContent.trim().length <= 2 && this.numberValidation(ilKodu.textContent))
        ) {
          this.getLine(ilKodu, ilKoduIndex, `Şüpheli işlem ${supheliIslemNumber}: <ilkodu> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-2.`);
        }
      }

      const ilceKodu = supheliIslem.getElementsByTagName('ilcekodu')[0];
      const ilceKoduIndex = this.findElementIndex(xmlDoc, ilceKodu, 'ilcekodu');
      if (islemkanali && (islemkanali.textContent == 'KK-01' || islemkanali.textContent == 'KK-10')) {
        if (!(ilceKodu && ilceKodu.textContent && ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
          this.getLine(
            ilceKodu,
            ilceKoduIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <ilcekodu> doğrulaması hatalı. 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
          );
        }
      } else {
        if (ilceKodu && ilceKodu.textContent && !(ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
          this.getLine(
            ilceKodu,
            ilceKoduIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <ilcekodu> doğrulaması hatalı. Opsiyoneldir ancak 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
          );
        }
      }

      const islemintetiklendigiyer = supheliIslem.getElementsByTagName('islemintetiklendigiyer')[0];
      const islemintetiklendigiyerIndex = this.findElementIndex(xmlDoc, islemintetiklendigiyer, 'islemintetiklendigiyer');
      if (
        !(
          islemintetiklendigiyer &&
          islemintetiklendigiyer.textContent &&
          Object.keys(SupheninTespitEdildigiBirimEnum).includes(islemintetiklendigiyer.textContent)
        )
      ) {
        this.getLine(
          islemintetiklendigiyer,
          islemintetiklendigiyerIndex,
          `Şüpheli işlem ${supheliIslemNumber}: <islemintetiklendigiyer> doğrulaması hatalı, geçerli işlem durumu seçilmeli`,
        );
      }

      const islemearaciliketmedurumu = supheliIslem.getElementsByTagName('islemearaciliketmedurumu')[0];
      const islemearaciliketmedurumuIndex = this.findElementIndex(xmlDoc, islemearaciliketmedurumu, 'islemearaciliketmedurumu');
      if (
        !(islemearaciliketmedurumu && islemearaciliketmedurumu.textContent && ['AED-01', 'AED-02', 'AED-03'].includes(islemearaciliketmedurumu.textContent))
      ) {
        this.getLine(
          islemearaciliketmedurumu,
          islemearaciliketmedurumuIndex,
          `Şüpheli işlem ${supheliIslemNumber}: <islemearaciliketmedurumu> doğrulaması hatalı, geçerli işlem durumu seçilmeli`,
        );
      }

      const islemearacilikedenkurum = supheliIslem.getElementsByTagName('islemearacilikedenkurum')[0];
      const islemearacilikedenkurumIndex = this.findElementIndex(xmlDoc, islemearacilikedenkurum, 'islemearacilikedenkurum');
      if (islemearaciliketmedurumu && (islemearaciliketmedurumu.textContent === 'AED-01' || islemearaciliketmedurumu.textContent === 'AED-03')) {
        if (!(islemearacilikedenkurum && islemearacilikedenkurum.textContent)) {
          this.getLine(
            islemearacilikedenkurum,
            islemearacilikedenkurumIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <islemearacilikedenkurum> doğrulaması hatalı, İşlem Aracılık Etme Durumu 'AED-01' veya 'AED-03' seçildiğinde islemearacilikedenkurum alanı zorunludur.`,
          );
        } else if (islemearacilikedenkurum.textContent.trim().length > 500) {
          this.getLine(
            islemearacilikedenkurum,
            islemearacilikedenkurumIndex,
            `Şüpheli işlem ${supheliIslemNumber}: <islemearacilikedenkurum> doğrulaması hatalı, 1 ile 500 karakter arasında olmalıdır.`,
          );
        }
      }

      const adresler = supheliIslem.getElementsByTagName('adresler')[0];
      const adres = adresler?.getElementsByTagName('adres');
      if (adres != undefined) {
        for (let i = 0; i < adres.length; i++) {
          const adresElement = adres[i];

          const adresSatir = adresElement.getElementsByTagName('adressatir')[0];
          const adresSatirIndex = this.findElementIndex(xmlDoc, adresSatir, 'adressatir');
          const tip = adresElement.getAttribute('tip');
          const tipElement = adresElement;
          const tipElementIndex = this.findElementIndex(xmlDoc, tipElement, 'adres');
          if (tip && !Object.keys(AdresEnum).includes(tip)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir adres tipi (merkez, sube, diger) girilmeli.`,
              1,
            );
          } else if (tip && (tip.length < 1 || tip.length > 6)) {
            this.getLine(
              tipElement,
              tipElementIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <tip> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-6 olmalıdır.`,
              1,
            );
          }
          if (!adresSatir || !adresSatir.textContent || adresSatir.textContent.trim().length === 0) {
            this.getLine(
              adresSatir,
              adresSatirIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <adressatir> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (!(adresSatir.textContent.trim().length >= 1 && adresSatir.textContent.trim().length <= 200)) {
            this.getLine(
              adresSatir,
              adresSatirIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <adressatir> doğrulaması hatalı. Karakter limiti 1-200 olmalıdır.`,
            );
          }

          const postaKodu = adresElement.getElementsByTagName('postakodu')[0];
          const postaKoduIndex = this.findElementIndex(xmlDoc, postaKodu, 'postakodu');
          if (postaKodu && postaKodu.textContent && postaKodu.textContent.trim().length > 0 && !(postaKodu.textContent.trim().length >= 1 && postaKodu.textContent.trim().length <= 10)) {
            this.getLine(
              postaKodu,
              postaKoduIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <postakodu> doğrulaması hatalı. Opsiyoneldir ancak karakter limiti 1-10 olmalıdır.`,
            );
          }

          const ilKodu = adresElement.getElementsByTagName('ilkodu')[0];
          const ilKoduIndex = this.findElementIndex(xmlDoc, ilKodu, 'ilkodu');
          if (
            ilKodu &&
            ilKodu.textContent &&
            !(ilKodu.textContent.trim().length >= 1 && ilKodu.textContent.trim().length <= 2 && this.numberValidation(ilKodu.textContent))
          ) {
            this.getLine(
              ilKodu,
              ilKoduIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <ilkodu> doğrulaması hatalı. Opsiyoneldir ancak 1-2 rakamdan oluşan plaka kodu olmalıdır.`,
            );
          }

          const ilceKodu = adresElement.getElementsByTagName('ilcekodu')[0];
          const ilceKoduIndex = this.findElementIndex(xmlDoc, ilceKodu, 'ilcekodu');
          if (ilceKodu && ilceKodu.textContent && !(ilceKodu.textContent.trim().length == 4 && this.numberValidation(ilceKodu.textContent))) {
            this.getLine(
              ilceKodu,
              ilceKoduIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <ilcekodu> doğrulaması hatalı. Opsiyoneldir ancak 4 rakamdan oluşan MERNİS ilçe kodları olmalıdır.`,
            );
          }

          const ulkeKodu = adresElement.getElementsByTagName('ulkekodu')[0];
          const ulkeKoduIndex = this.findElementIndex(xmlDoc, ulkeKodu, 'ulkekodu');
          if (!ulkeKodu || !ulkeKodu.textContent || ulkeKodu.textContent.trim().length === 0) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <ulkekodu> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (ulkeKodu.textContent.trim().length !== 2 || !this.letterValidation(ulkeKodu.textContent.trim())) {
            this.getLine(
              ulkeKodu,
              ulkeKoduIndex,
              `Şüpheli işlem ${supheliIslemNumber}, adres ${i + 1}: <ulkekodu> doğrulaması hatalı. ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.`,
            );
          }
        }
      }

      const iletisimBilgileri = supheliIslem.getElementsByTagName('iletisimbilgileri')[0];
      const iletisimBilgisi = iletisimBilgileri?.getElementsByTagName('iletisimbilgisi');
      if (iletisimBilgisi != undefined && iletisimBilgisi.length > 0) {
        const iletisimBilgileriIndex = this.findElementIndex(xmlDoc, iletisimBilgileri, 'iletisimbilgileri');
        for (let i = 0; i < iletisimBilgisi.length; i++) {
          const iletisimBilgisiElement = iletisimBilgisi[i];

          const tip = iletisimBilgisiElement.getAttribute('tip');
          const content = iletisimBilgisiElement?.textContent?.trim() || '';
          const iletisimBilgisiIndex = this.findElementIndex(xmlDoc, iletisimBilgisiElement, 'iletisimbilgisi');

          if (tip && !Object.keys(IletisimEnum).includes(tip)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Şüpheli işlem ${supheliIslemNumber}, iletişim bilgisi ${i + 1}: <tip> doğrulaması hatalı. Geçerli bir tip girilmeli.`,
            );
          }
          if (!content || content.length === 0) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Şüpheli işlem ${supheliIslemNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> zorunlu alandır ve girilmesi gerekmektedir.`,
            );
          } else if (!(content.length >= 7 && content.length <= 50)) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Şüpheli işlem ${supheliIslemNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. 7-50 karakter girilmelidir.`,
            );
          }
          if (tip === 'eposta' && content && !content.includes('@')) {
            this.getLine(
              iletisimBilgisiElement,
              iletisimBilgisiIndex,
              `Şüpheli işlem ${supheliIslemNumber}, iletişim bilgisi ${i + 1}: <iletisimbilgisi> doğrulaması hatalı. E-posta adresi "@" işareti içermelidir.`,
            );
          }
        }
      }
    }
  }

  private hesaplarValidation(xmlDoc: Document) {
    const hesaplar = xmlDoc.getElementsByTagName('hesap');
    if (hesaplar == undefined) return;

    for (let i = 0; i < hesaplar.length; i++) {
      const hesap = hesaplar[i];
      const hesapNumber = i + 1;

      const sahisfirmasihesabi = hesap.getElementsByTagName('sahisfirmasihesabi')[0];
      const sahisfirmasihesabiIndex = this.findElementIndex(xmlDoc, sahisfirmasihesabi, 'sahisfirmasihesabi');
      if (!(sahisfirmasihesabi && sahisfirmasihesabi.textContent && (sahisfirmasihesabi.textContent == 'E' || sahisfirmasihesabi.textContent == 'H'))) {
        this.getLine(
          sahisfirmasihesabi,
          sahisfirmasihesabiIndex,
          `Hesap ${hesapNumber}: <sahisfirmasihesabi> doğrulaması hatalı, E(Şahıs Hesabı) veya H(Şahıs Hesabı Değil) girilmelidir.`,
        );
      }

      const hesapturu = hesap.getElementsByTagName('hesapturu')[0];
      const hesapturuIndex = this.findElementIndex(xmlDoc, hesapturu, 'hesapturu');
      if (!(hesapturu && hesapturu.textContent && Object.keys(HesapTuruEnum).includes(hesapturu.textContent))) {
        this.getLine(hesapturu, hesapturuIndex, `Hesap ${hesapNumber}: <hesapturu> doğrulaması hatalı. Geçerli bir hesap türü seçilmelidir.`);
      }

      const hesapno = hesap.getElementsByTagName('hesapno')[0];
      const hesapnoIndex = this.findElementIndex(xmlDoc, hesapno, 'hesapno');
      if (hesapno && hesapno.textContent && !(hesapno.textContent.trim().length >= 1 && hesapno.textContent.trim().length <= 30)) {
        this.getLine(hesapno, hesapnoIndex, `Hesap ${hesapNumber}: <hesapno> doğrulaması hatalı. 1-30 karakter içermelidir.`);
      }

      const iban = hesap.getElementsByTagName('iban')[0];
      const ibanIndex = this.findElementIndex(xmlDoc, iban, 'iban');
      if (iban && iban.textContent && !(iban.textContent.trim().length >= 15 && iban.textContent.trim().length <= 34)) {
        this.getLine(
          iban,
          ibanIndex,
          `Hesap ${hesapNumber}: <iban> doğrulaması hatalı. 15-34 karakter içermelidir. ISO 13616:1997 standardına uygun olmalıdır.`,
        );
      }

      const acilistarihi = hesap.getElementsByTagName('acilistarihi')[0];
      const acilistarihiIndex = this.findElementIndex(xmlDoc, acilistarihi, 'acilistarihi');
      if (!(acilistarihi && acilistarihi.textContent)) {
        this.getLine(acilistarihi, acilistarihiIndex, `Hesap ${hesapNumber}: <acilistarihi> tarihi boş olamaz.`);
      } else {
        this.tarihValidation(acilistarihi, acilistarihiIndex, acilistarihi.textContent, `Hesap ${hesapNumber}: <acilistarihi>`);
      }

      const kapanistarihi = hesap.getElementsByTagName('kapanistarihi')[0];
      const kapanistarihiIndex = this.findElementIndex(xmlDoc, kapanistarihi, 'kapanistarihi');
      if (kapanistarihi && kapanistarihi.textContent) {
        this.tarihValidation(kapanistarihi, kapanistarihiIndex, kapanistarihi.textContent, `Hesap ${hesapNumber}: <kapanistarihi>`);
      }

      const sonislemtarihi = hesap.getElementsByTagName('sonislemtarihi')[0];
      const sonislemtarihiIndex = this.findElementIndex(xmlDoc, sonislemtarihi, 'sonislemtarihi');
      if (sonislemtarihi && sonislemtarihi.textContent) {
        this.tarihValidation(sonislemtarihi, sonislemtarihiIndex, sonislemtarihi.textContent, `Hesap ${hesapNumber}: Opsiyoneldir ancak <sonislemtarihi>`);
      }

      const bakiyetp = hesap.getElementsByTagName('bakiyetp')[0];
      const bakiyetpIndex = this.findElementIndex(xmlDoc, bakiyetp, 'bakiyetp');
      if (bakiyetp && bakiyetp.textContent) {
        const bakiyetpValue = bakiyetp.textContent.trim();
        const bakiyetpRegex = /^\d{1,15}(\.\d{1,5})?$/;
        if (!bakiyetpRegex.test(bakiyetpValue)) {
          this.getLine(
            bakiyetp,
            bakiyetpIndex,
            `Hesap ${hesapNumber}: <bakiyetp> hatalı: Değer ${bakiyetpValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
          );
        }
      }

      const bakiye = hesap.getElementsByTagName('bakiye')[0];
      const bakiyeIndex = this.findElementIndex(xmlDoc, bakiye, 'bakiye');
      if (bakiye && bakiye.textContent) {
        const bakiyeValue = bakiye.textContent.trim();
        const bakiyeRegex = /^\d{1,15}(\.\d{1,5})?$/;
        if (!bakiyeRegex.test(bakiyeValue)) {
          this.getLine(
            bakiye,
            bakiyeIndex,
            `Hesap ${hesapNumber}: <bakiye> hatalı: Değer ${bakiyeValue} geçerli bir formatta değil. Beklenen format: ###############.#####`,
          );
        }
      }

      const parabirimi = hesap.getElementsByTagName('parabirimi')[0];
      const parabirimiIndex = this.findElementIndex(xmlDoc, parabirimi, 'parabirimi');
      if (!(parabirimi && parabirimi.textContent && Object.keys(ParaBirimiEnum).includes(parabirimi.textContent))) {
        this.getLine(
          parabirimi,
          parabirimiIndex,
          `Hesap ${hesapNumber}: <parabirimi> doğrulaması hatalı, geçerli para birimi seçilmeli, ISO 4217 standardında olmalıdır.`,
        );
      }

      const kisitlamaturu = hesap.getElementsByTagName('kisitlamaturu')[0];
      const kisitlamaturuIndex = this.findElementIndex(xmlDoc, kisitlamaturu, 'kisitlamaturu');
      if (kisitlamaturu && kisitlamaturu.textContent && kisitlamaturu.textContent.trim().length >= 1 && kisitlamaturu.textContent.trim().length <= 500) {
        const ktTypes = kisitlamaturu.textContent.split(',');
        ktTypes.forEach((type) => {
          if (!Object.keys(KisitlamaTuruEnum).includes(type.trim())) {
            this.getLine(kisitlamaturu, kisitlamaturuIndex, `Hesap ${hesapNumber}: <kisitlamaturu> doğrulaması hatalı: ${type.trim()} geçerli bir tip değil.`);
          }
        });
      }

      const kisitlamadigeraciklama = hesap.getElementsByTagName('kisitlamadigeraciklama')[0];
      const kisitlamadigeraciklamaIndex = this.findElementIndex(xmlDoc, kisitlamadigeraciklama, 'kisitlamadigeraciklama');
      if (kisitlamaturu && kisitlamaturu.textContent === 'YK-07') {
        if (
          !(
            kisitlamadigeraciklama &&
            kisitlamadigeraciklama.textContent &&
            kisitlamadigeraciklama.textContent.trim().length > 1 &&
            kisitlamadigeraciklama.textContent.trim().length <= 250
          )
        ) {
          this.getLine(
            kisitlamadigeraciklama,
            kisitlamadigeraciklamaIndex,
            `Hesap ${hesapNumber}: <kisitlamadigeraciklama> doğrulaması hatalı: 1-250 karakterden küçük olmalı.`,
          );
        }
      } else {
        if (
          kisitlamadigeraciklama &&
          kisitlamadigeraciklama.textContent &&
          !(kisitlamadigeraciklama.textContent.trim().length > 1 && kisitlamadigeraciklama.textContent.trim().length <= 250)
        ) {
          this.getLine(
            kisitlamadigeraciklama,
            kisitlamadigeraciklamaIndex,
            `Hesap ${hesapNumber}: <kisitlamadigeraciklama> doğrulaması hatalı: Opsiyonelir ancak 1-250 karakterden küçük olmalı.`,
          );
        }
      }

      const hesapsahipleri = hesap.getElementsByTagName('hesapsahipleri')[0];
      const hesapsahibi = hesapsahipleri?.getElementsByTagName('hesapsahibi');
      if (hesapsahibi != undefined) {
        for (let i = 0; i < hesapsahibi.length; i++) {
          const hesapsahibiElement = hesapsahibi[i];

          const magdur = hesapsahibiElement.getElementsByTagName('magdur')[0];
          const magdurIndex = this.findElementIndex(xmlDoc, magdur, 'magdur');
          if (!(magdur && magdur.textContent && (magdur.textContent == 'E' || magdur.textContent == 'H'))) {
            this.getLine(
              magdur,
              magdurIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <magdur> doğrulaması hatalı, E(Mağdur) veya H(Mağdur Değil) girilmelidir.`,
            );
          }

          const adsoyadunvan = hesapsahibiElement.getElementsByTagName('adsoyadunvan')[0];
          const adsoyadunvanIndex = this.findElementIndex(xmlDoc, adsoyadunvan, 'adsoyadunvan');
          if (!(adsoyadunvan && adsoyadunvan.textContent && adsoyadunvan.textContent.trim().length >= 1 && adsoyadunvan.textContent.trim().length <= 250)) {
            this.getLine(
              adsoyadunvan,
              adsoyadunvanIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <adsoyadunvan> doğrulaması hatalı, 1-250 karakter içermelidir.`,
            );
          }

          const tckn = hesapsahibiElement.getElementsByTagName('tckn')[0];
          const tcknIndex = this.findElementIndex(xmlDoc, tckn, 'tckn');
          if (tckn && tckn.textContent && !(tckn.textContent.trim().length == 11 && this.numberValidation(tckn.textContent))) {
            this.getLine(
              tckn,
              tcknIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <tckn> doğrulaması hatalı, opsiyoneldir ancak 11 rakamdan oluşan gerçek bir TCKN girilmelidir`,
            );
          }

          const vkn = hesapsahibiElement.getElementsByTagName('vkn')[0];
          const vknIndex = this.findElementIndex(xmlDoc, vkn, 'vkn');
          if (vkn && vkn.textContent && !(vkn.textContent.trim().length == 10 && this.numberValidation(vkn.textContent))) {
            this.getLine(
              vkn,
              vknIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <vkn> doğrulaması hatalı, opsiyoneldir ancak 10 rakamdan oluşan gerçek bir VKN girilmelidir`,
            );
          }

          const ykn = hesapsahibiElement.getElementsByTagName('ykn')[0];
          const yknIndex = this.findElementIndex(xmlDoc, ykn, 'ykn');
          if (ykn && ykn.textContent && !(ykn.textContent.trim().length == 11 && this.numberValidation(ykn.textContent))) {
            this.getLine(
              ykn,
              yknIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <ykn> doğrulaması hatalı, opsiyoneldir ancak 11 rakamdan oluşan gerçek bir YKN girilmelidir`,
            );
          }

          const pasaport = hesapsahibiElement.getElementsByTagName('pasaport')[0];
          const pasaportIndex = this.findElementIndex(xmlDoc, pasaport, 'pasaport');
          if (pasaport && pasaport.textContent && !(pasaport.textContent.trim().length >= 1 && pasaport.textContent.trim().length <= 20)) {
            this.getLine(
              pasaport,
              pasaportIndex,
              `Hesap ${hesapNumber}, hesapsahibi ${i + 1}: <pasaport> doğrulaması hatalı, opsiyoneldir ancak 1-20 karakter içermeli.`,
            );
          }
        }
      }
    }
  }

  private supheKategorileriValidation(xmlDoc: Document) {
    const suphekategorileri = xmlDoc.getElementsByTagName('suphekategorileri')[0];
    if (suphekategorileri == undefined) return;

    const suphekategorisi = suphekategorileri.getElementsByTagName('suphekategorisi');
    for (let i = 0; i < suphekategorisi.length; i++) {
      const suphekategorisiElement = suphekategorisi[i];

      const suphekategorisiElementIndex = this.findElementIndex(xmlDoc, suphekategorisiElement, 'suphekategorisi');
      if (!(suphekategorisiElement && suphekategorisiElement.textContent && Object.keys(SupheKategorileriEnum).includes(suphekategorisiElement.textContent))) {
        this.getLine(
          suphekategorisiElement,
          suphekategorisiElementIndex,
          `Şüphe kategorisi ${i + 1}: <suphekategorisi> doğrulaması hatalı. Doğru tip seçilmelidir.`,
        );
      }
    }
  }

  private bildirimAciklamaValidation(xmlDoc: Document) {
    const element = xmlDoc.getElementsByTagName('bildirimaciklama')[0];
    const elementIndex = this.findElementIndex(xmlDoc, element, 'bildirimaciklama');
    if (!(element && element.textContent && element.textContent.trim().length >= 100 && element.textContent.trim().length <= 50000)) {
      this.getLine(element, elementIndex, 'Bildirim açıklaması doğrulaması hatalı, 100-50000 karakter içermelidir.');
    }
  }

  private tarihValidation(element: Element, skip: number, field: string, text: string) {
    const dateString = field.trim();
    const datePattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19[0-9]{2}|20[0-9]{2})$/;
    if (!datePattern.test(dateString)) {
      this.getLine(element, skip, `${text} tarihi GG/AA/YYYY formatında olmalıdır.`);
    }

    const [day, month, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const today = new Date();
    const minDate = new Date(1900, 0, 1);
    if (date > today) {
      this.getLine(element, skip, `${text} tarihi bugünün tarihinden sonraki bir tarih olamaz.`);
    } else if (date < minDate) {
      this.getLine(element, skip, `${text} tarihi 01/01/1900 tarihinden önceki bir tarih olamaz.`);
    }
  }

  private getCalculateElementNumber(element: Element, offset: number): { lineStart: number; lineEnd: number; colStart: number; colEnd: number } {
    const xmlLines = this.xmlContent.split('\n');
    let lineStart = 0;
    let colStart = 0;
    let lineEnd = 0;
    let colEnd = 0;
    let skipped = 0;

    for (let i = 0; i < xmlLines.length; i++) {
      const regex = new RegExp(`<${element?.tagName}(\\s|>)`);
      if (xmlLines[i]?.match(regex)) {
        if (offset <= skipped) {
          lineStart = i + 1;
          colStart = xmlLines[i].indexOf(element?.tagName) + 1;
          break;
        } else {
          skipped++;
        }
      }
    }

    for (let i = lineStart - 1; i < xmlLines.length; i++) {
      if (xmlLines[i]?.includes(`</${element?.tagName}>`)) {
        lineEnd = i + 1;
        colEnd = xmlLines[i].length;
        break;
      }
    }
    return { lineStart, lineEnd, colStart, colEnd };
  }

  private getLine = (element: Element, offset: number, message: string, skip: number = 0) => {
    const { lineStart, lineEnd, colStart, colEnd } = this.getCalculateElementNumber(element, offset);
    this.validationResult.isValid = false;
    this.validationResult.errors.push({
      message: message,
      lineStart: lineStart - skip,
      lineEnd: lineEnd - skip,
      colStart: colStart - skip,
      colEnd: colEnd - skip,
    });
  };

  public findElementIndex(xmlDocument: Document, targetElement: Element, tag: string) {
    const allElement = xmlDocument.getElementsByTagName(tag);
    for (let i = 0; i < allElement.length; i++) {
      if (allElement[i] === targetElement) {
        return i;
      }
    }
    return -1;
  }

  private numberValidation(field: string): boolean {
    const validation = /^[0-9]+$/;
    return validation.test(field);
  }

  private letterValidation(field: string): boolean {
    const validation = /^[A-Za-z]+$/;
    return validation.test(field);
  }
}

export default SarXmlValidation;
